import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import styles from "./PanelCornerDots.module.css";
type PanelCornerDotsProps = {
  className?: string;
  dotClassName?: string;
};

/** Decorative corner accent row (two dots) for framed aops panels. */
export function PanelCornerDots(t0) {
  const $ = _c(14);
  const {
    className,
    dotClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.ellipsesRow, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dotClassName) {
    t2 = cn(styles.dot, dotClassName);
    $[2] = dotClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dotClassName) {
    t4 = cn(styles.dot, dotClassName);
    $[6] = dotClassName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className={t1} aria-hidden={true}>{t3}{t5}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}